import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Integration, IntegrationEvent } from '@glomex/integration-react';
import loadAdSlot from 'app/components/ads/loadAdSlot';
import { useLayout } from 'app/contexts/LayoutContext';
import { LayoutMode } from 'app/styles/LayoutMode';
import { AdSlot } from 'app/components/ads/AdSlot';
import { AdUnit } from 'app/components/ads/AdUnit';
const GlomexPlayer = _ref => {
  let {
    integrationId,
    playlistId
  } = _ref;
  const [load, setLoad] = useState(false);
  const [passback, setPassback] = useState(false);
  const integrationRef = useRef(null);
  const layout = useLayout();
  const isDesktop = layout !== LayoutMode.Mobile;
  useLayoutEffect(() => {
    loadAdSlot('ad-Glomex_Player', () => setLoad(true), isDesktop);
  }, [isDesktop]);
  const handlePassback = () => {
    // When Glomex signals passback, unmount the integration and render our GPT fallback slot
    setPassback(true);
  };
  useEffect(() => {
    const el = integrationRef.current;
    el === null || el === void 0 || el.addEventListener(IntegrationEvent.INTEGRATION_PASSBACK, handlePassback);
    return () => {
      el === null || el === void 0 || el.removeEventListener(IntegrationEvent.INTEGRATION_PASSBACK, handlePassback);
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    id: "ad-Glomex_Player",
    "data-sentry-component": "GlomexPlayer",
    "data-sentry-source-file": "GlomexPlayer.tsx"
  }, load && (passback ? /*#__PURE__*/React.createElement(AdSlot, {
    adUnit: AdUnit.Rectangle_2,
    limitedDim: true
  }) : /*#__PURE__*/React.createElement(Integration, {
    ref: integrationRef,
    playlistId: playlistId,
    integrationId: integrationId
    /*@ts-ignore*/,
    passback: handlePassback
  })));
};
export default GlomexPlayer;